import {ObjectLiteral} from "typeorm/browser/common/ObjectLiteral";
import {IRepository} from "./IRepository";
import {FindManyOptions,  Repository} from "typeorm";
import {FindOneOptions} from "typeorm/browser/find-options/FindOneOptions";
import {SaveOptions} from "typeorm/browser/repository/SaveOptions";
import {DeepPartial} from "typeorm/browser/common/DeepPartial";
import {EntityTarget} from "typeorm/browser/common/EntityTarget";
import LocalDataSource from "../../data-sources/LocalDataSource";
import {Entidade} from "../../domain/Entidade";
import {EnumSincronizacao} from "../../domain/EnumSincronizacao";
import {Grupo} from "../../domain/enums";

export class LocalRepository <Entity extends ObjectLiteral> implements IRepository<Entity>{
  private repo: Repository<Entity>
  constructor(private target:  EntityTarget<Entity>) {
    this.repo = LocalDataSource.getRepository(target)
  }
  async delete<T extends DeepPartial<Entity>>(object: T): Promise<T> {
    const ent = object as Entidade
    ent.situacao = EnumSincronizacao.ENVIAR
    ent.excluido = true
    return await this.repo.save(object)
  }

  find(options?: FindManyOptions<Entity>): Promise<Entity[]> {
    return this.repo.find(options)
  }

  findAndCount(options?: FindManyOptions<Entity>): Promise<[Entity[], number]> {
    return this.repo.findAndCount(options)
  }

  findTaxon(grupos:Grupo[], texto: string): Promise<Entity[]> {
    let query =  this.repo.createQueryBuilder()
      .limit(100)
      .where("taxon MATCH :nome", {nome: texto})

    if(grupos?.length > 0 ) {
       query = query.andWhere("grupo in (:...grupos)", {grupos: grupos})
    }
    return query.getMany()
  }

  findOne(options: FindOneOptions<Entity>): Promise<Entity> {
    return this.repo.findOne(options)
  }

  findOneOrFail(options: FindOneOptions<Entity>): Promise<Entity> {
    return this.repo.findOneOrFail(options)
  }

  async save<T extends DeepPartial<Entity>>(entity: T, options?: SaveOptions): Promise<T> {
    // const entidade =  entity as Entidade
    // if(!entidade.situacao)
    //     entidade.situacao = EnumSincronizacao.ENVIAR
    return await this.repo.save(entity, options)
  }

}
